import PourApprovalPage from './PourApprovalPage';
import StopeNoteApprovalPage from './StopeNoteApprovalPage';

const PublicModule = {
  pages: [
    PourApprovalPage,
    StopeNoteApprovalPage,
  ],
};

export default PublicModule;
